import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import style from '../styles/Settings.module.css';

export function Settings() {
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };
  return (
    <div>
      <button className={style.signOutBtn} onClick={handleSignOut}>
        Sign Out
      </button>
    </div>
  );
}
